import { configureStore } from '@reduxjs/toolkit';
import authReducer from "../redux/userAuth/authSlice"
import userDetail from 'src/redux/user/userSlice';
import forgetPasswordSlice from 'src/redux/userAuth/forgetPasswordSlice';
import roleDetail from 'src/redux/roles&permission/roleSlice';
import permissionDetail from 'src/redux/roles&permission/permissionSlice';
const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userDetail,
    password: forgetPasswordSlice,
    role: roleDetail,
    permission: permissionDetail
  },
});

export default store;